import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Text,
  Select,
  SimpleGrid,
} from "@chakra-ui/react";

interface VehicleInfoCardProps {
  licensePlateNumber: string;
  carModel: string;
  vinNumber: string;
  carMaker: string;
  carMakersData?: any[];
  isLoadingMakers?: boolean;
  onLicensePlateChange: (value: string) => void;
  onCarModelChange: (value: string) => void;
  onVinNumberChange: (value: string) => void;
  onCarMakerChange: (value: string) => void;
}

const VehicleInfoCard: React.FC<VehicleInfoCardProps> = ({
  licensePlateNumber,
  carModel,
  vinNumber,
  carMaker,
  carMakersData,
  isLoadingMakers,
  onLicensePlateChange,
  onCarModelChange,
  onVinNumberChange,
  onCarMakerChange,
}) => {
  return (
    <Box
      width="100%"
    >
      <Box mb={5} borderBottom="1px solid lightgrey" pb={2}>
        <Text fontWeight="bold">Vehicle Information</Text>
      </Box>
      <VStack spacing={4} align="stretch">
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 3, md: 4 }}>
          <FormControl>
            <FormLabel fontSize="smaller" fontWeight="medium">
              Select Maker*
            </FormLabel>
            <Select
              placeholder={isLoadingMakers ? "Loading..." : "Select..."}
              value={carMaker}
              onChange={(e) => {
                const selectedValue = e.target.value;
                if (selectedValue) {
                  onCarMakerChange(selectedValue);
                } else {
                  onCarMakerChange("");
                }
              }}
              bgColor="white"
            >
              {carMakersData?.map((maker: any, index: number) => {
                const makerName = maker.name || maker.makerName || "";
                return (
                  <option key={index} value={makerName}>
                    {makerName}
                  </option>
                );
              })}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel fontSize="smaller" fontWeight="medium">
              License Plate Number
            </FormLabel>
            <Input
              placeholder="Enter license plate number"
              value={licensePlateNumber}
              onChange={(e) => onLicensePlateChange(e.target.value)}
              bgColor="white"
            />
          </FormControl>
        </SimpleGrid>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 3, md: 4 }}>
          <FormControl>
            <FormLabel fontSize="smaller" fontWeight="medium">
              Car Model
            </FormLabel>
            <Input
              placeholder="Enter car model"
              value={carModel}
              onChange={(e) => onCarModelChange(e.target.value)}
              bgColor="white"
            />
          </FormControl>
          <FormControl>
            <FormLabel fontSize="smaller" fontWeight="medium">
              VIN Number
            </FormLabel>
            <Input
              placeholder="Enter VIN number"
              value={vinNumber}
              onChange={(e) => onVinNumberChange(e.target.value)}
              bgColor="white"
            />
          </FormControl>
        </SimpleGrid>
      </VStack>
    </Box>
  );
};

export default VehicleInfoCard;
